(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  const intro = document.querySelector('[data-vtx-intro]');
  if (intro) {
    let hasPlayed = false;
    try { hasPlayed = window.sessionStorage.getItem('vtx-intro-played') === 'true'; } catch (error) { hasPlayed = false; }
    if (hasPlayed || reduceMotion) {
      intro.remove();
    } else {
      document.documentElement.classList.add('vtx-intro-active');
      window.setTimeout(() => {
        intro.classList.add('is-done');
        document.documentElement.classList.remove('vtx-intro-active');
        try { window.sessionStorage.setItem('vtx-intro-played', 'true'); } catch (error) { /* Storage may be unavailable in a privacy context. */ }
      }, 2550);
      window.setTimeout(() => intro.remove(), 3300);
    }
  }

  const mobileMenuButton = document.querySelector('[data-vtx-menu-toggle]');
  const mobileMenu = document.querySelector('[data-vtx-mobile-menu]');
  if (mobileMenuButton && mobileMenu) {
    const syncMenu = () => {
      const open = mobileMenuButton.getAttribute('aria-expanded') === 'true';
      document.body.classList.toggle('vtx-menu-open', open);
      mobileMenuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    };
    mobileMenuButton.addEventListener('click', () => window.requestAnimationFrame(syncMenu));
    mobileMenu.addEventListener('click', (event) => {
      if (!event.target.closest('a')) return;
      mobileMenu.classList.add('hidden');
      mobileMenuButton.setAttribute('aria-expanded', 'false');
      syncMenu();
    });
  }

  const hero = document.querySelector('[data-vtx-hero]');
  if (hero && !reduceMotion) {
    hero.addEventListener('pointermove', (event) => {
      const bounds = hero.getBoundingClientRect();
      hero.style.setProperty('--mx', ((event.clientX - bounds.left) / bounds.width - .5).toFixed(3));
      hero.style.setProperty('--my', ((event.clientY - bounds.top) / bounds.height - .5).toFixed(3));
    }, { passive: true });
    hero.addEventListener('pointerleave', () => {
      hero.style.setProperty('--mx', '0');
      hero.style.setProperty('--my', '0');
    });
    let queued = false;
    const updateHeroScroll = () => {
      queued = false;
      const offset = Math.min(window.scrollY * .085, 54);
      hero.style.setProperty('--scrolly', `${offset}px`);
    };
    window.addEventListener('scroll', () => {
      if (queued || window.scrollY > hero.offsetHeight + 120) return;
      queued = true;
      window.requestAnimationFrame(updateHeroScroll);
    }, { passive: true });
  }

  const reveals = $$('.vtx-reveal');
  if (reduceMotion || !('IntersectionObserver' in window)) {
    reveals.forEach((element) => element.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver((entries, revealObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .12 });
    reveals.forEach((element) => observer.observe(element));
  }

  const counters = $$('[data-vtx-count]');
  const animateCount = (element) => {
    if (element.dataset.vtxCounted === 'true') return;
    element.dataset.vtxCounted = 'true';
    const target = Number(element.dataset.vtxCount || 0);
    const prefix = element.dataset.vtxPrefix || '';
    const suffix = element.dataset.vtxSuffix || '';
    if (reduceMotion || !Number.isFinite(target)) {
      element.textContent = `${prefix}${target}${suffix}`;
      return;
    }
    const start = performance.now();
    const duration = 1100;
    const frame = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 4);
      element.textContent = `${prefix}${Math.round(target * eased)}${suffix}`;
      if (progress < 1) window.requestAnimationFrame(frame);
    };
    window.requestAnimationFrame(frame);
  };
  if ('IntersectionObserver' in window && !reduceMotion) {
    const counterObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        animateCount(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: .5 });
    counters.forEach((element) => counterObserver.observe(element));
  } else {
    counters.forEach(animateCount);
  }

  $$('[data-vtx-faq-button]').forEach((button) => {
    const item = button.closest('[data-vtx-faq-item]');
    const answer = item?.querySelector('[data-vtx-faq-answer]');
    if (!item || !answer) return;
    button.addEventListener('click', () => {
      const shouldOpen = button.getAttribute('aria-expanded') !== 'true';
      item.classList.toggle('is-open', shouldOpen);
      button.setAttribute('aria-expanded', String(shouldOpen));
      answer.setAttribute('aria-hidden', String(!shouldOpen));
    });
  });
})();
